if (!customElements.get('handler-standorte')) {
    customElements.define('handler-standorte',
        class HandlerStandorte extends HTMLElement {
            constructor() {
                super();
            }

            inMap() {

                let clazz = this;
                let lat = 0, lng = 0;
                for (let i = 0; i < window.storeLocations.length; i++) {
                    lat += parseFloat(window.storeLocations[i].lat);
                    lng += parseFloat(window.storeLocations[i].lng);
                }

                lat /= window.storeLocations.length;
                lng /= window.storeLocations.length;

                this.map = new google.maps.Map(document.getElementById("store-map"), {
                    zoom: 6,
                    center: {lat: lat, lng: lng},
                    mapId: "6c5a89ed8bf71f4d"
                });

                const cityFilter = document.getElementById('city-filter');
                const countryFilter = document.getElementById('country-filter');

                const locations = window.storeLocations.map(loc => {
                    return {
                        name: loc.name,
                        address: loc.street + " " + loc.numb + ", " + loc.stadt.desc,
                        lat: parseFloat(loc.lat),
                        lng: parseFloat(loc.lng),
                        city: loc.stadt.desc || '',
                        country: loc.stadt.land.desc || ''
                    };
                });

                this.populateFilters(locations);
                this.renderMarkers(locations, clazz, true);

                cityFilter.addEventListener('change', (e) => {
                    const filtered = this.filterLocations(locations);
                    this.renderMarkers(filtered, clazz);
                    this.setCities(filtered);
                });

                countryFilter.addEventListener('change', (e) => {
                    let selected = countries.sort().filter(function (item, pos, ary) {
                        return item.desc === e.currentTarget.value || (e.currentTarget.value === '' && item.desc === "Deutschland");
                    });

                    clazz.filterCities(locations, e.currentTarget.value);
                    const filtered = clazz.filterLocations(locations, e.currentTarget.value);
                    clazz.renderMarkers(filtered,clazz, true, selected[0]);
                    clazz.setCountry();
                });

                let map = this.map;
                let markers = this.markers;

            }


            setCities() {
                const city = document.getElementById('city-filter').value;
                let selectedCountry = "";
                document.querySelectorAll('.storeCard').forEach((e) => {
                    if (e.dataset.city === city || city === '') {
                        e.classList.remove("hidden");
                        selectedCountry = e.dataset.country;
                    } else {
                        e.classList.add("hidden");
                    }
                });
                if (selectedCountry !== "") {
                    document.querySelectorAll('.countryCards').forEach((e) => {
                        if (e.dataset.country === selectedCountry || city === '') {
                            e.classList.remove("hidden");
                            selectedCountry = e.dataset.country;
                        } else {
                            e.classList.add("hidden");
                        }
                    });
                }
            }

            setCountry() {
                const country = document.getElementById('country-filter').value;
                document.querySelectorAll('.storeCard').forEach((e) => {
                    if (e.dataset.country === country || country === '') {
                        e.classList.remove("hidden");
                    } else {
                        e.classList.add("hidden");
                    }
                });
                document.querySelectorAll('.countryCards').forEach((e) => {
                    if (e.dataset.country === country || country === '') {
                        e.classList.remove("hidden");
                        this.selectedCountry = e.dataset.country;
                    } else {
                        e.classList.add("hidden");
                    }
                });
            }

            renderMarkers(locations, clazz, init = false, select = null) {
                // Clear previous markers & clusters
                if(clazz.markers !== undefined)
                    clazz.markers.forEach(marker => marker.setMap(null));
                clazz.markers = [];
                if (clazz.markerCluster) {
                    clazz.markerCluster.clearMarkers();
                }

                locations.forEach(loc => {
                    let map = clazz.map;
                    const marker = new google.maps.marker.AdvancedMarkerElement({
                        map,
                        position: {lat: loc.lat, lng: loc.lng},
                        title: loc.name
                    });

                    const info = new google.maps.InfoWindow({
                        content: `<strong>${loc.name}</strong><br>${loc.address}<br>${loc.city}, ${loc.country}`
                    });

                    marker.addListener('click', () => info.open(map, marker));
                    clazz.markers.push(marker);
                });

                // Add Marker Clusterer
                let map = clazz.map;
                let markers = clazz.markers;
                const markerCluster = new markerClusterer.MarkerClusterer({ map, markers });

                if (locations.length > 0 && !init) {

                    let lat = 0, lng = 0;
                    for (let i = 0; i < locations.length; i++) {
                        lat += parseFloat(locations[i].lat);
                        lng += parseFloat(locations[i].lng);

                    }

                    lat /= locations.length;
                    lng /= locations.length;

                    clazz.map.setCenter({lat: locations[0].lat, lng: locations[0].lng});
                    clazz.map.setZoom(10);
                }

                if (select !== null) {
                    clazz.map.setCenter({lat: parseFloat(select.lat), lng: parseFloat(select.lng)});
                    clazz.map.setZoom(parseInt(select.zoom));
                }

            }

            filterLocations(locations) {
                const city = document.getElementById('city-filter').value;
                const country = document.getElementById('country-filter').value;

                return locations.filter(loc =>
                    (city === "" || loc.city === city) &&
                    (country === "" || loc.country === country)
                );
            }

            populateFilters(locations) {
                const citySet = new Set();
                const countrySet = new Set();

                locations.forEach(loc => {
                    citySet.add(loc.city);
                    countrySet.add(loc.country);
                });

                const cityFilter = document.getElementById('city-filter');
                citySet.forEach(city => {
                    const opt = document.createElement('option');
                    opt.value = city;
                    opt.textContent = city;
                    cityFilter.appendChild(opt);
                });

                const countryFilter = document.getElementById('country-filter');
                countrySet.forEach(country => {
                    const opt = document.createElement('option');
                    opt.value = country;
                    opt.textContent = country;
                    countryFilter.appendChild(opt);
                });
            }

            filterCities(locs, target) {
                const citySet = new Set();
                const cityFilter = document.getElementById('city-filter');

                while (cityFilter.childElementCount > 0)
                    cityFilter.removeChild(cityFilter.children[0]);
                locs.forEach(loc => {
                    if (loc.country === target || target === '')
                        citySet.add(loc.city);
                });


                const opt = document.createElement('option');
                opt.value = "";
                opt.textContent = "Alle Städte";
                cityFilter.appendChild(opt);

                citySet.forEach(city => {
                    const opt = document.createElement('option');
                    opt.value = city;
                    opt.textContent = city;
                    cityFilter.appendChild(opt);
                });
            }

        })
}
